/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Secondary_Color_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Secondary Color" |
*
* @param {Styles_Secondary_Color_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_secondary_color_aria_label = /** @type {((inputs?: Styles_Secondary_Color_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Secondary_Color_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Couleur secondaire")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sekundärfarbe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Colore secondario")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вторичный цвет")
	if (locale === "es") return /** @type {LocalizedString} */ ("Color secundario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("辅助色")
	if (locale === "ja") return /** @type {LocalizedString} */ ("二次色")
	if (locale === "hi") return /** @type {LocalizedString} */ ("द्वितीयक रंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cor secundária")
	return /** @type {LocalizedString} */ ("Secondary Color")
});